<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">Details needed in the MDRS1</h4>
      <small class="form-text text-muted"
        >For the selected country
        {{ this.$store.getters.selectedCountry | uppercase }}</small
      >
    </div>
    <div class="card-body">
      <div
        class="form-group"
        v-bind:key="holder.Slug"
        v-for="(holder, index) in $v.placeHolders.$each.$iter"
      >
        <label v-bind:for="holder.$model.Slug" :class="index">{{
          holder.$model.Title
        }}</label>
        <input
          class="form-control"
          v-if="holder.$model.Type === 'Text'"
          type="text"
          v-bind:id="holder.$model.Slug"
          v-model="holder.$model.DefaultValue"
        />
        <small
          v-if="holder.$model.Description"
          id="carrierHelp"
          class="form-text text-muted"
          >{{ holder.$model.Description }}</small
        >
        <div class="error" v-if="!holder.DefaultValue.isValid">
          Please enter a valid value for {{ holder.$model.Title }}.
        </div>
        <div class="error" v-if="!holder.DefaultValue.isRequired">
          Please enter a value for {{ holder.$model.Title }}.
        </div>
      </div>
      <button class="btn btn-secondary" @click="goback">
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon
        >Back
      </button>
      <button
        class="btn btn-info mx-2"
        v-bind:disabled="nextable"
        @click="gonext"
      >
        Next
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </button>
    </div>
  </div>
</template>

<script>
import serviceProxy from "../services/index";
import _ from "lodash";
import { required, email, helpers } from "vuelidate/lib/validators";
const phNo = helpers.regex("phNo", /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/);
const zipCode = helpers.regex("zipCode", /^\d{5}(-\d{4})?$/);
const canadazipCode = helpers.regex(
  "canadazipCode",
  /^[abceghjklmnprstvxy][0-9][abceghjklmnprstvwxyz]\s?[0-9][abceghjklmnprstvwxyz][0-9]$/i
);
export default {
  name: "mdrs1mtmtemplate",
  computed: {
    nextable() {
      this.$v.placeHolders.$touch();
      if (this.$v.placeHolders.$invalid) {
        return true;
      }
      var that = this;
      return !(
        _.filter(this.placeHolders, ph => {
          if (ph.Slug) {
            if (ph.DefaultValue === null || ph.DefaultValue.trim() === "") {
              return true;
            } else {
              return false;
            }
          }
          return false;
        }).length === 0
      );
    }
  },
  created() {
    let that = this;
    let selectedDocument = this.$store.getters.selectedDocumenttype.toUpperCase();
    let selectedCountry = this.$store.getters.selectedCountry.toUpperCase();
    let selectedBusiness = this.$store.getters.selectedBusinessType.toUpperCase();
    let country = _.clone(selectedCountry);
    let documentType = _.clone(selectedDocument);
    let businessType = _.clone(selectedBusiness);
    that.$root.$emit("removestage");
    that.$root.$emit("progress");
    that.$root.$emit("toast", {
      title: "Fetching Data",
      message: "Fetching Template Placeholders"
    });
    serviceProxy.template
      .getMDRS1MtMTemplate(this.$store.getters.token, businessType, country)
      .then(data => {
        let response = data.data;
        let templateConfig = _.clone(data.data);
        _.each(templateConfig.PlaceHolders, holder => {
          holder.DefaultValue = holder.DefaultValue || "";
          that.placeHolders.push(holder);
        });
        that.template = templateConfig.Slug;
        that.title = templateConfig.Title;
        that.$store.commit("mdrmtmtemplateconfig", templateConfig);
        that.$root.$emit("done");
        that.$root.$emit("toast", {
          title: "Fetched Template",
          message: "Fetched Template Placeholders"
        });
      })
      .catch(e => {
        that.$root.$emit("done");
        that.$root.$emit("toast", {
          title: "OOPS",
          message: "Error in fetching the data"
        });
      });
  },
  data() {
    return {
      placeHolders: [],
      placeHolderValues: [],
      createAgainMode: this.$store.getters.createAgainMode,
      template: "",
      title: ""
    };
  },
  methods: {
    goback: function(oEvent) {
      this.$router.go(-1);
    },
    gonext: function(oEvent) {
      var that = this;
      let phValues = _.map(this.placeHolders, ph => {
        return {
          Slug: ph.Slug,
          Value: ph.DefaultValue
        };
      });
      this.$store.commit("placeholders", phValues);
      this.$router.push({ path: "generate-mdrs1mtm" });
    }
  },
  filters: {
    uppercase: function(value, onlyFirstCharacter) {
      if (!value) {
        return "";
      }
      value = value.toString();
      if (onlyFirstCharacter) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      } else {
        return value.toUpperCase();
      }
    }
  },
  validations: {
    placeHolders: {
      $each: {
        DefaultValue: {
          isRequired(defaultValue, ph) {
            if (ph.Slug) {
              if (ph.DefaultValue === null || ph.DefaultValue.trim() === "") {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          },
          isValid(defaultValue, placeHolder) {
            if (defaultValue != null && defaultValue != "") {
              if (placeHolder.Slug.indexOf("email") != -1) {
                return email(defaultValue);
              } else if (placeHolder.Slug.indexOf("contactnumber") != -1) {
                return phNo(defaultValue);
              } else if (placeHolder.Slug.indexOf("zip") != -1) {
                if (zipCode(defaultValue) || canadazipCode(defaultValue)) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return true;
              }
            } else {
              return true;
            }
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.error {
  color: red;
  border-color: #fdd;
}
</style>